import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BeratungsprotokollService {
  private apiUrl = 'https://localhost:5001/api/beratungsprotokoll'; // Örnek

  constructor(private http: HttpClient) {}

  createProtokoll(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/create`, data);
  }

  uploadProtokollPdf(protocolId: number, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<string>(
      `${this.apiUrl}/${protocolId}/uploadPdf`,
      formData
    );
  }

  updateProtokoll(data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${data.id}`, data);
  }

  generatePdf(protokollId: number): Observable<string> {
    return this.http.post<string>(
      `${this.apiUrl}/${protokollId}/generatePdf`,
      {}
    );
  }

  sendEmail(protokollId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${protokollId}/sendEmail`, {});
  }
}
